import { Header } from '@fe-toolkit/web-components/ssr'
import { accountLinks, headerLinks } from '@fe-toolkit/utility'

type FallbackHeaderProps = {
  username?: string
}

export default function FallbackHeader({ username }: FallbackHeaderProps) {
  return (
    <Header
      accountLinks={accountLinks}
      authUrlDashboard="/dashboard"
      authUrlLogIn="/auth/login"
      authUrlLogOut="/auth/logout"
      links={headerLinks}
      position="sticky"
      username={username}
    />
  )
}
